<template>
  <el-dialog title="Указание приоритета" :visible="visible" v-on="$listeners" @close="onClose">
    <el-form id="formPriority" label-position="right" label-width="155px">
      <el-form-item label="Критерий">
        <el-select
          :value="priorityTypeId"
          placeholder="Выберите критерий"
          style="width: 100%"
          @change="setPriorityType"
        >
          <el-option
            v-for="priorityType in priorityTypesList"
            :key="priorityType.id"
            :label="priorityType.label"
            :value="priorityType.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="priorityTypeId == priorityTypes.allClientCameras" label="Клиент">
        <select-client
          size="default"
          :owner-id="clientId"
          @change="(client) => (clientId = client.id_account)"
        />
      </el-form-item>
      <el-form-item v-if="priorityTypeId == priorityTypes.allTariffCameras" label="Тариф">
        <select-tariff size="default" :tariff-id="tarrifId" @change="(tariff) => (tarrifId = tariff.id_tariff)" />
      </el-form-item>
      <el-form-item v-if="priorityTypeId == priorityTypes.allServerCameras" label="Медиа-сервер">
        <dvr-servers-select size="default" v-model="serverId" />
      </el-form-item>
      <el-form-item v-if="priorityTypeId == priorityTypes.cameraByNimbleId" label="Камера">
        <select-camera
          size="default"
          :camera-id="cameraId"
          @change="setNimbleId"
        />
      </el-form-item>
      <el-form-item v-if="priorityTypeId !== null" label="Значение приоритета">
        <el-input-number style="width: 100%" v-model="priority" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :disabled="loading" @click="onClose">Отменить</el-button>
      <el-button
        id="savePriority"
        :disabled="isSavePriorityButtonDisabled"
        :loading="loading"
        type="primary"
        @click="onSave"
      >
        Сохранить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import isNull from "lodash/isNull"
import SelectClient from "@/core/components/features/SelectClient";
import SelectTariff from "@/components/Tariffs/components/feature/SelectTariff";
import DvrServersSelect from "@/components/Server/feature/DvrServersSelect";
import SelectCamera from "@/core/components/features/SelectCamera";
import { priorityTypes, priorityTypesText } from "@/components/Priorities/consts";

export default {
  name: "AddPriorityDialog",
  components: {
    SelectClient,
    SelectTariff,
    DvrServersSelect,
    SelectCamera
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    savePriority: {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      priorityTypes,
      priorityTypesText,
      priorityTypeId: null,
      clientId: null,
      tarrifId: null,
      serverId: null,
      nimbleId: null,
      cameraId: null,
      priority: 100,
    };
  },
  computed: {
    priorityTypesList() {
      return Object.values(priorityTypes).map(type_id => ({ id: type_id, label: priorityTypesText[type_id] }));
    },
    isSavePriorityButtonDisabled() {
      return this.priorityTypeId == null
        || (this.priorityTypeId == priorityTypes.allClientCameras && this.clientId == null)
        || (this.priorityTypeId == priorityTypes.allTariffCameras && this.tarrifId == null)
        || (this.priorityTypeId == priorityTypes.allServerCameras && this.serverId == null)
        || (this.priorityTypeId == priorityTypes.cameraByNimbleId && this.nimbleId == null);
        
    },
  },
  watch: {
    visible(visible) {
      if (!visible) {
        this.priorityTypeId = null;
        this.priority = 100;
        this.setNullToAllIds();
      }
    },
  },
  methods: {
    setPriorityType(id_type) {
      this.priorityTypeId = id_type;
      this.setNullToAllIds();
    },
    setNimbleId(camera) {
      this.nimbleId = camera.nimble_id;
      this.cameraId = camera.id_camera;
    },
    onSave() {
      const newPriority = {
        type: this.priorityTypeId,
        priority: this.priority
      };

      if (!isNull(this.clientId)) newPriority.id_account = this.clientId;
      if (!isNull(this.tarrifId)) newPriority.id_tariff = this.tarrifId;
      if (!isNull(this.serverId)) newPriority.id_server = this.serverId;
      if (!isNull(this.nimbleId)) newPriority.nimble_id = this.nimbleId;

      this.savePriority(newPriority);
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    setNullToAllIds() {
      this.clientId = null;
      this.tarrifId = null;
      this.serverId = null;
      this.nimbleId = null;
      this.cameraId = null;
    }
  },
};
</script>
